var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74072 23.7248C20.6799 23.7248 26.6621 14.6454 26.6621 6.77215C26.6621 6.51429 26.6568 6.2576 26.6453 6.00199C27.8092 5.15824 28.8138 4.11348 29.6119 2.91668C28.5463 3.39127 27.3995 3.71072 26.1967 3.85475C27.4244 3.11704 28.3671 1.95026 28.8118 0.559239C27.6443 1.25312 26.3671 1.74223 25.0353 2.00551C23.9501 0.847402 22.4051 0.123047 20.6942 0.123047C17.4099 0.123047 14.7466 2.79136 14.7466 6.08044C14.7466 6.54801 14.7988 7.00281 14.9009 7.43901C9.95802 7.18982 5.57506 4.81893 2.64173 1.21382C2.11342 2.12303 1.83552 3.15645 1.83642 4.2085C1.83642 6.27563 2.88637 8.10051 4.48299 9.16809C3.53858 9.13922 2.61488 8.88366 1.78953 8.42287C1.78866 8.44792 1.78866 8.47228 1.78866 8.49898C1.78866 11.3845 3.83866 13.7937 6.55993 14.3396C6.04883 14.4791 5.52144 14.5496 4.99172 14.5493C4.61658 14.5491 4.24231 14.5131 3.87397 14.4419C4.63113 16.8092 6.82665 18.532 9.42964 18.5801C7.39413 20.1785 4.82996 21.1305 2.04312 21.1305C1.56367 21.1305 1.09005 21.1032 0.624512 21.0481C3.25659 22.7383 6.38193 23.7245 9.74101 23.7245",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.9e1d7bce69ac7cb5a7b71451feed8ee5.svg";
export { ForwardRef as ReactComponent };